<template>
  <div class="calendar-sidebar">
    <b-button
      variant="primary"
      class="create-btn"
      @click="$emit('newEvent')"
    >
      <feather-icon
        icon="PlusIcon"
        size="18"
        class="mr-2"
      />
      Novo Agendamento
    </b-button>

    <!-- Status Filter -->
    <div class="filter-card">
      <h5 class="filter-title">
        Status
      </h5>
      <div class="filter-list">
        <b-form-checkbox
          :checked="selectedStatuses.length === statusOptions.length"
          class="mb-2 font-weight-bold"
          @change="toggleAllStatuses"
        >
          Visualizar Todos
        </b-form-checkbox>
        <b-form-checkbox
          v-for="status in statusOptions"
          :key="status.value"
          :checked="selectedStatuses.includes(status.value)"
          class="status-checkbox mb-1"
          :style="{ '--check-color': status.color }"
          @change="$emit('toggleStatus', status.value, $event)"
        >
          {{ status.label }}
        </b-form-checkbox>
      </div>
    </div>

    <!-- Motivo Filter -->
    <div class="filter-card">
      <h5 class="filter-title">
        Motivo
      </h5>
      <div class="filter-list">
        <b-form-checkbox
          :checked="showAllMotivos"
          class="mb-2 font-weight-bold"
          @change="toggleAllMotivos"
        >
          Visualizar Todos
        </b-form-checkbox>
        <b-form-checkbox
          v-for="motivo in motivoOptions"
          :key="motivo.value"
          :checked="showAllMotivos || selectedMotivos.includes(motivo.value)"
          class="status-checkbox mb-1"
          @change="$emit('toggleMotivo', motivo.value, $event)"
        >
          {{ motivo.label }}
        </b-form-checkbox>
      </div>
    </div>

    <!-- Executivo Selector -->
    <div
      v-if="isNotExecutivoCobranca && executivosComAgendamentos.length > 0"
      class="filter-card"
    >
      <h5 class="filter-title">
        Executivo
      </h5>
      <div class="filter-list">
        <b-form-checkbox
          :checked="selectedExecutivos.length === executivosComAgendamentos.length"
          class="mb-2 font-weight-bold"
          @change="toggleAllExecutivos"
        >
          Visualizar Todos
        </b-form-checkbox>
        <div class="filter-items ">
          <b-form-checkbox
            v-for="exec in executivosComAgendamentos"
            :key="exec.value"
            :checked="selectedExecutivos.includes(exec.value)"
            class="mb-1"
            @change="$emit('toggleExecutivo', exec.value, $event)"
          >
            {{ exec.label }}
          </b-form-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton, BFormCheckbox } from 'bootstrap-vue'
import { statusOptions, motivoOptions } from '../calendar-utils'

export default {
  name: 'CalendarSidebar',
  components: { BButton, BFormCheckbox },
  props: {
    selectedStatuses: { type: Array, default: () => [] },
    selectedMotivos: { type: Array, default: () => [] },
    showAllMotivos: { type: Boolean, default: true },
    selectedExecutivos: { type: Array, default: () => [] },
    isNotExecutivoCobranca: { type: Boolean, default: true },
    executivosComAgendamentos: { type: Array, default: () => [] },
  },
  data() {
    return { statusOptions, motivoOptions }
  },
  computed: {
    statusGroups() {
      return []
    },
  },
  methods: {
    toggleAllStatuses(checked) {
      if (checked) {
        this.statusOptions.forEach(s => {
          if (!this.selectedStatuses.includes(s.value)) {
            this.$emit('toggleStatus', s.value, true)
          }
        })
      } else {
        this.selectedStatuses.forEach(s => this.$emit('toggleStatus', s, false))
      }
    },
    toggleAllMotivos(checked) {
      if (checked) {
        this.$emit('clearMotivos')
      } else {
        this.$emit('uncheckAllMotivos')
      }
    },
    toggleAllExecutivos(checked) {
      if (checked) {
        this.executivosComAgendamentos.forEach(e => {
          if (!this.selectedExecutivos.includes(e.value)) {
            this.$emit('toggleExecutivo', e.value, true)
          }
        })
      } else {
        this.selectedExecutivos.forEach(e => this.$emit('toggleExecutivo', e, false))
      }
    },
  },
}
</script>

<style scoped>
.calendar-sidebar {
  width: 17rem;
  flex-shrink: 0;
  border-right: 1px solid #dadce0;
  background: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.create-btn {
  min-height: 3rem;
  width: auto;
  border-radius: 9999px;
  background: #fff;
  color: #3c4043;
  padding: 12px 20px;
  box-shadow: 0 1px 2px rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15);
  border: none;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.create-btn:hover {
  background: #f8fafd;
  box-shadow: 0 1px 3px rgba(60,64,67,0.3), 0 4px 8px 3px rgba(60,64,67,0.15);
}

.filter-card {
  border-radius: 16px;
  padding: 12px;
  margin-bottom: 16px;
}

.filter-card:hover {
  background: #f8fafd;
}

.filter-title {
  font-size: 13px;
  font-weight: 500;
  color: #3c4043;
  margin-bottom: 12px;
}

.filter-list {
  font-size: 13px;
  color: #3c4043;
}

.filter-items {
  margin-left: 16px;
  margin-top: 4px;
}

.filter-items .custom-control {
  margin-bottom: 4px;
}

.priority-group {
  margin-top: 8px;
}

.status-checkbox {
  font-size: 12px;
  font-weight: 500;
  display: block !important;
  margin-bottom: 0;
}

.status-checkbox + .status-checkbox {
  margin-top: 4px;
}

@media (max-width: 991.98px) {
  .calendar-sidebar {
    display: none;
  }
}
</style>

<style>
.calendar-sidebar .status-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: var(--check-color, #1a73e8) !important;
  border-color: var(--check-color, #1a73e8) !important;
}

.calendar-sidebar .status-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e") !important;
}
</style>
